<template>
    <v-flex class="relative-position">
        <v-flex class="form-control">
            <v-text-field
                label="Solo"
                placeholder="Enter Name"
                solo
                @click="showSearchSuggestions = true"
                clearable
                v-model="speakerSearchText"
                @keydown.enter="searchSpeakerByName"
                @keyup="getAutoCompleteSearchSpeakers()"
                :data-qe-id='!checkCFF ? "speaker_search-text" : "cFFSearch_text"'
                @click:clear="clearSpeakerAutoCompleteSearch()"
                hide-details></v-text-field>
            <v-btn class="primary_btn small search-btn" @click="searchSpeakerByName()">{{
                SpeakerApplicants.SEARCH
            }}</v-btn>
        </v-flex>
        <v-flex
            xs12
            class="find-speaker-result"
            v-if="
                showSearchSuggestions &&
                    $route.query.speakerSearchText !== speakerSearchText &&
                    speakerSearchText.length > 2
            ">
            <status-overlay :action="getSpeakerSearchSuggestionsAction"></status-overlay>
            <v-flex
                v-for="(speaker, i) in speakerSearchSuggestions.slice(0, 5)"
                :key="i"
                @click="openSpeakerProfilePage(speaker, $router, $route.query)"
                class="find-speaker-result__list">
                <img :src="speaker.profileImageUrl" :onerror="imageErrorFallback(speaker.fallbackProfileImageUrl)" />
                <span>{{
                    `${speaker.preferredName ? speaker.preferredName : speaker.firstName} ${speaker.lastName}`
                }}</span>
                <strong :name="i">{{
                        speaker.recordTypeName.toLowerCase() == 'speaker' ||
                        speaker.recordTypeName.toLowerCase() == 'event speaker'
                            ? 'Non-Member'
                            : speaker.recordTypeName
                    }}
                    {{ speaker.primaryChapter ? ` | ${speaker.primaryChapter}` : '' }}</strong>
                <small :name="i">{{ speaker.title }}</small>
            </v-flex>

            <span v-if="speakerSearchSuggestions && speakerSearchSuggestions.length > 5" @click="searchSpeakerByName()" class="find-speaker-result__see-all">See All</span>
            <v-flex class="custom-popover__bg" @click="showSearchSuggestions = false"></v-flex>

            <v-flex class="find-speaker-result__list find-speaker-result__no-result" v-if="
                    speakerSearchSuggestions &&
                        speakerSearchSuggestions.length === 0 &&
                        speakerSearchText.length > 2 &&
                        !getSpeakerSearchSuggestionsAction.pending &&
                        !timeoutForTypeAhead
                ">
                <span>{{ SpeakerApplicants.NO_FILTER_RESULTS }}</span>
            </v-flex>
        </v-flex>
    </v-flex>
</template>

<script>
    import { SpeakerApplicants, openSpeakerProfilePage } from "../Speakers/speakerConstant";
    import { mapActions, mapState, mapMutations } from "vuex";
    import { storeAction } from "../../store/storeActions.constant";
    import { storeMutation } from "../../store/storeMutations.constant";
    import StatusOverlay from "@/components/StatusOverlay/StatusOverlay";
    import { imageErrorFallback } from "../../common/utils/utils";

    export default {
        data: () => ({
            speakerSearchText: '',
            showSearchSuggestions: false,
            speakerSearchSuggestions: [],
            SpeakerApplicants,
            timeoutForTypeAhead: null,
        }),
        props: {
            checkCFF: {
                type: Boolean,
                required: true,
            },
        },
        created() {
            this.speakerSearchText = this.$route.query.speakerSearchText || '';
        },
        components: {
            StatusOverlay,
        },
        methods: {
            ...mapActions({
                getSpeakerSearchSuggestions: `searchSpeaker/${storeAction.getSpeakerSearchSuggestions}`,
            }),
            openSpeakerProfilePage,
            imageErrorFallback,
            clearSpeakerAutoCompleteSearch() {
                this.speakerSearchText = '';
                this.speakerSearchSuggestions = [];
            },
            searchSpeakerByName() {
                if (this.$route.query.speakerSearchText !== this.speakerSearchText) {
                    if (
                        this.$route.query.speakersWhoAre &&
                        this.$route.query.speakersWhoAre.includes(this.SpeakerApplicants.IS_CFF_SPEAKER)
                    ) {
                        this.$router.push({
                            query: {
                                speakersWhoAre: this.SpeakerApplicants.IS_CFF_SPEAKER,
                                speakerSearchText: this.speakerSearchText,
                            },
                        });
                    } else {
                        this.$router.push({
                            query: {
                                speakerSearchText: this.speakerSearchText,
                            },
                        });
                    }
                }
            },
            getAutoCompleteSearchSpeakers() {
                const prevSearchText = this.$route.query.speakerSearchText || '';
                if (!this.speakerSearchText) {
                    this.clearSpeakerAutoCompleteSearch();
                }
                if (prevSearchText !== this.speakerSearchText) {
                    this.showSearchSuggestions = true;
                    clearTimeout(this.timeoutForTypeAhead);
                    this.timeoutForTypeAhead = setTimeout(() => {
                        this.timeoutForTypeAhead = null;
                        if (this.speakerSearchText && this.speakerSearchText.length > 2) {
                            this.isSearchSpeakers = true;
                            const postBody = { search: this.speakerSearchText };
                            if (
                                this.$route.query.speakersWhoAre &&
                                this.$route.query.speakersWhoAre.includes(this.SpeakerApplicants.IS_CFF_SPEAKER)
                            ) {
                                postBody.searchFilters = [{ filterKey: "IsCFFSpeaker", filterValue: true }];
                            }
                            this.getSpeakerSearchSuggestions(postBody).then((data) => {
                                data.forEach((d) => {
                                    d.profileImageUrl = `${d.profileImageUrl}?${new Date().getTime()}`;
                                });
                                this.speakerSearchSuggestions = [];
                                setTimeout(() => {
                                    this.speakerSearchSuggestions = data;
                                }, 0);
                            });
                        }
                    }, 1000);
                }
            },
        },
        computed: {
            ...mapState('actionState', ['actions']),
            getSpeakerSearchSuggestionsAction() {
                return this.actions[storeAction.getSpeakerSearchSuggestions];
            },
        },
    };
</script>
